"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateIntermediateFields = void 0;
const formula_engine_1 = require("@finley-technologies/formula-engine");
const _isMissingVariableFormulaEngine = (errorMessage) => {
    return errorMessage.startsWith('unknown variable:');
};
const validateIntermediateFields = (params) => {
    const errors = [];
    const queryResultSet = new Set();
    params.queryResults.forEach(({ name }) => {
        if (queryResultSet.has(name)) {
            errors.push(`Duplicate query result variable [${name}]`);
        }
        else {
            queryResultSet.add(name);
        }
    });
    const intermediateFieldSet = new Set();
    params.intermediateFields.forEach(({ field, config }) => {
        if (field === '') {
            errors.push('Intermediate field name is empty');
            return;
        }
        if (intermediateFieldSet.has(field)) {
            errors.push(`Duplicate intermediate field [${field}]`);
            return;
        }
        intermediateFieldSet.add(field);
        const { errorMessages, missingVariables } = (0, formula_engine_1.getFormulaErrors)(config.formula, queryResultSet);
        if (errorMessages.length > 0) {
            // Conditionally basing on "queryResults" since it's possible that it's purposely
            // empty when utilizing this validation since some "queryResults" relies on async
            // methods. e.g., empty params makes sense for certain client side validation flows.
            // In those cases, ignoring if all formula errors are related to missing variables.
            if (params.queryResults.length === 0) {
                if (errorMessages.length !== missingVariables.length) {
                    errorMessages.forEach((error) => {
                        const isMissingVariable = _isMissingVariableFormulaEngine(error);
                        if (!isMissingVariable) {
                            errors.push(`Intermediate formula error [field:${field}] [error:${error}]`);
                        }
                    });
                    return;
                }
            }
            else {
                errorMessages.forEach((error) => {
                    errors.push(`Intermediate formula error [field:${field}] [error:${error}]`);
                });
                return;
            }
        }
        if (queryResultSet.has(field)) {
            errors.push(`Duplicate intermediate field & query result variable [${field}]`);
            return;
        }
        queryResultSet.add(field);
    });
    return errors;
};
exports.validateIntermediateFields = validateIntermediateFields;
//# sourceMappingURL=intermediateFieldsValidate.js.map